
@switch (columnId) {
  @case ('id') {
    <lib-text-table-column>
      {{ element.id }}
    </lib-text-table-column>
  }
  @case ('webhook') {
    <lib-text-table-column horizAlign="right">
      {{ element.webhookUrl }}
    </lib-text-table-column>
  }
  @case ('solution') {
    <lib-text-table-column>
      {{ element.webhookSolutionName }}
    </lib-text-table-column>
  }
  @case ('status') {
    <lib-status-chip
      class="event-delivery-statuses"
      [status]="element.status">
    </lib-status-chip>
  }
  @case ('createdUtc') {
    <lib-date-time-label [dateUtc]="element.createdUtc"></lib-date-time-label>
  }
  @case ('resend') {
    <lib-vitu-tooltip text="Resend">
      <i class="far fa-redo global-table-cell-image-link" (click)="onClickResend()"></i>
    </lib-vitu-tooltip>
  }
  @default {
  }
}
